import fetch from 'isomorphic-fetch';
const makeFetchRequest = async (endPoint) => {
  let res = await fetch('https://jsonplaceholder.typicode.com/' + endPoint);
  let response = await res.json();
  return response;
}

export { makeFetchRequest };

